import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { DeepgramVoice, deepgramVoiceList } from '../deepgram';

@Component({
  selector: 'app-select-deepgram',
  standalone: true,
  imports: [CommonModule, FormsModule, NzSelectModule],
  templateUrl: './select-deepgram.component.html',
  styleUrl: './select-deepgram.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SelectDeepgramComponent,
      multi: true,
    },
  ],
})
export class SelectDeepgramComponent {
  @Input() value: string = '';

  getLabel(deepgramVoice: DeepgramVoice) {
    return `${deepgramVoice.gender} - ${deepgramVoice.accent}`;
  }

  getDeepgramVoiceList() {
    return deepgramVoiceList;
  }

  // ControlValueAccessor interface methods
  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Handle the disabled state if necessary
  }

  // Method to handle value changes
  handleValueChange(value: string): void {
    this.value = value;

    console.log('------ value:', value);

    this.onChange(value);
    this.onTouched();
  }
}
